import React from 'react'
import { useTranslation } from 'react-i18next'
import AnalyticSeriesChart, {
    AnalyticSeriesData,
} from '../../../shared/AnalyticSeriesChart'

interface DurationChartProps {
    data?: AnalyticSeriesData
}

// LMS live-stream transcoding duration (hours). Single-metric time series from
// the margarita-backed endpoint (type=/lms_transcoding_duration).
const DurationChart: React.FC<DurationChartProps> = ({ data }) => {
    const { t } = useTranslation()
    return (
        <AnalyticSeriesChart
            data={data}
            title={t('services.duration-of-live')}
            unit="hours"
            color="#2563eb"
            variant="area"
            totalLabel="Total Hours"
            emptyText="No duration data available for the selected period"
        />
    )
}

export default DurationChart
